import React, { Component } from "react";
import axios from "axios";
import { HOST_URL } from "../../helpers/constants/Constants";
import Select from "react-select";
import { featureList } from "./FeatureList";

export class FeedBackTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      feedbackList: [],
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    setTimeout(() => {
      axios({
        method: "post",
        url: HOST_URL + `/api/getfeedback`,
      })
        .then((response) => {
          this.setState({
            feedbackList: response.data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }, 400);
  };

  saveData = () => {
    const formData = new FormData();
    formData.append("Data", JSON.stringify(this.state.feedbackList));

    setTimeout(() => {
      axios({
        method: "post",
        url: HOST_URL + `/api/savefeedbackcomment`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          alert("Data Saved");
        })
        .catch((error) => {
          console.log(error);
        });
    }, 400);
  };

  removeRow = (index) => {
    this.setState({
      feedbackList: this.state.feedbackList.filter(
        (obj, idx) => obj.Id !== index
      ),
    });
  };

  updateComments = (elem) => {
    var tempFeedbackList = this.state.feedbackList.map((item, idx) => {
      if (item.Id != elem.target.id) {
        return item;
      } else {
        return {
          Id: item.Id,
          Feature: item.Feature,
          User: item.User,
          Feedback: item.Feedback,
          Comment: elem.target.value,
          IsFaq: item.IsFaq,
          IsCritical: item.IsCritical,
        };
      }
    });

    this.setState({
      feedbackList: tempFeedbackList,
    });
  };

  handleCheckBoxChange = (elem) => {
    var tempFeedbackList = this.state.feedbackList.map((item, idx) => {
      if (item.Id != elem.target.id) {
        return item;
      } else {
        return {
          ...item,
          IsFaq: elem.target.checked,
        };
      }
    });
    this.setState({
      feedbackList: tempFeedbackList,
    });
  };

  handleCriticalBoxTicked = (elem) => {
    var tempFeedbackList = this.state.feedbackList.map((item, idx) => {
      if (item.Id != elem.target.id) {
        return item;
      } else {
        return {
          ...item,
          IsCritical: elem.target.checked,
        };
      }
    });

    this.setState({
      feedbackList: tempFeedbackList,
    });
  };

  handleFeatureChange = (elem) => {
    var tempFeedbackList = this.state.feedbackList.map((item, idx) => {
      console.log("item.Id = ", item.Id);
      console.log("elem.Id = ", elem.id);
      if (item.Id !== elem.id) {
        return item;
      } else {
        return {
          ...item,
          Feature: elem.value,
        };
      }
    });

    this.setState({
      feedbackList: tempFeedbackList,
    });
  };

  render() {
    return (
      <div
        style={{
          textAlign: "center",
        }}
      >
        {console.log("feedbackList = ", this.state.feedbackList)}
        <div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.loadData}
          >
            Load Data
          </button>
        </div>
        <br />
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <table className="table " align="center">
            <thead>
              <tr>
                <th>Feature</th>
                <th>Feedback</th>
                <th>User</th>
                <th>Comment</th>
                <th>Is FAQ</th>
                <th>Is Critical</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {console.log("feedback List = ", this.state.feedbackList)}
              {this.state.feedbackList.map((item, index) => {
                return (
                  <tr key={item.Id}>
                    <td style={{ width: "250px" }}>
                      {/* {item.Feature} */}
                      <Select
                        // className="form-control-sm"
                        classNamePrefix={"typeahead-select"}
                        value={item.Feature}
                        onChange={this.handleFeatureChange}
                        options={featureList.map((featureItem) => {
                          return {
                            value: featureItem,
                            label: featureItem,
                            id: item.Id,
                          };
                        })}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        placeholder={item.Feature}
                      />
                    </td>
                    <td>{item.Feedback}</td>
                    <td>{item.User}</td>
                    <td>
                      <textarea
                        id={item.Id}
                        type="text"
                        placeholder="Enter comment"
                        value={item.Comment}
                        onChange={this.updateComments}
                      />
                    </td>
                    <td>
                      <div className="col-8 p-0">
                        <input
                          type="checkbox"
                          id={item.Id}
                          defaultChecked={item.IsFaq}
                          onChange={this.handleCheckBoxChange}
                        />
                        <label htmlFor={item.Id}></label>
                      </div>
                    </td>
                    <td>
                      <div className="col-8 p-0">
                        <input
                          type="checkbox"
                          id={item.Id}
                          defaultChecked={item.IsCritical}
                          onChange={this.handleCriticalBoxTicked}
                        />
                        <label htmlFor={item.Id}></label>
                      </div>
                    </td>
                    <td
                      style={{
                        backgroundColor: "#FFFF",
                        borderTopColor: "#FFFF",
                      }}
                      onClick={() => {
                        const r = window.confirm(
                          "Are you sure you want to delete this feedback row?"
                        );
                        if (r === false) {
                          return;
                        }
                        this.removeRow(item.Id);
                      }}
                    >
                      Delete
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.saveData}
        >
          Save Data
        </button>
      </div>
    );
  }
}

export default FeedBackTable;
